var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"name"},[_c('p',[_vm._v(_vm._s(_vm.item.title)+" ")])]),_c('div',{staticClass:"created"},[_c('p',[_vm._v("Tillagd "+_vm._s(_vm.dateString)+" "+_vm._s(_vm.humanDate))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }